import { render } from "./EditCollectionModal.vue?vue&type=template&id=96486bd8"
import script from "./EditCollectionModal.vue?vue&type=script&lang=js"
export * from "./EditCollectionModal.vue?vue&type=script&lang=js"

import "./EditCollectionModal.vue?vue&type=style&index=0&id=96486bd8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__